import React, { useState, useEffect } from 'react';
import {
  CircularProgress,Table, TableBody, TableCell, TableContainer, TableRow, TableHead,Paper
} from '@mui/material';
import axios from 'axios';
import ChartCard from "../shared/ChartCard";


const Tipemilik = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const beUrl = process.env.REACT_APP_BE
  
    useEffect(() => {
      // Fungsi untuk mengambil data dari API
      const fetchData = async () => {
          try {
              const response = await axios.get(`${beUrl}/api/v1/pgsql/DetailjumlahPinjam`);
              setData(response.data.data); // Simpan data ke state
              setIsLoading(false); // Set loading selesai
          } catch (error) {
              console.error("Error fetching data: ", error);
              setIsLoading(false); // Tetap hentikan loading walaupun error
          }
      };

      fetchData(); // Panggil fungsi fetchData ketika komponen mount
  }, []);
  
  
  return (
    <div>
       {isLoading ? ( // Tampilkan CircularProgress jika isLoading true
        <CircularProgress style={{ margin: '50px auto', display: 'block' }} />
      ) : data.length === 0 ? ( // Check if data is empty
        <ChartCard>
          <h6 className="text-center text-sm xl:text-lg font-medium">
            Data Peminjaman Tidak Ada!
          </h6>
        </ChartCard>
      ) : (
        
        <TableContainer component={Paper} style={{ marginTop: '20px', maxHeight: 400   }}>
        <Table stickyHeader>
          <TableHead>
              <TableRow>
              <TableCell align='center' style={{ backgroundColor: ' #0288d1', color: 'white' }}>No</TableCell>
              <TableCell align='center' style={{ backgroundColor: ' #0288d1', color: 'white' }}>Keperluan</TableCell>
              <TableCell align='center' style={{ backgroundColor: ' #0288d1', color: 'white' }}>Jumlah</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {data.map((item, index) => (
                <TableRow key={index}>
                <TableCell align="center" >{index + 1}</TableCell>
                <TableCell  >{item.keperluan}</TableCell>
                <TableCell align="center" >{Math.round(item.jumlah).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</TableCell>
                </TableRow>
            ))}
          </TableBody>
          </Table>
      </TableContainer>
      
      )}
</div>

  );
}
export default Tipemilik;